import React from 'react';

const SVG = ({
  style = {},
  fill = '#9192a4',
  width = '100%',
  className = '',
  viewBox = '0 0 30 30',
  title = 'Activity',
}: any) => (
  <svg
    fill={fill}
    width={width}
    style={style}
    className={`svg ${className}`}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <style>
        {`
          .svg-activity-1 { fill: none; }
          .svg-fill-activity { fill: ${fill}; }
        `}
      </style>
    </defs>
    <title>{title}</title>
    <g id="Layer_2" data-name="Layer 2">
      <g id="Layer_1-2" data-name="Layer 1">
        <rect className="svg-activity-1" width="30" height="30" />
        <path
          className="svg-fill-activity"
          d="M26.51,23.47l-2.8-2.75A5.7,5.7,0,0,0,21.78,13V8.25a3.08,3.08,0,0,0-3.09-3h-.9a1.21,1.21,0,0,0-1.1-.67H15a2.4,2.4,0,0,0-4.75,0H8.18a1.23,1.23,0,0,0-1.1.67H6.17A3.07,3.07,0,0,0,3.08,8.25v16.2A3.07,3.07,0,0,0,6.17,27.5H18.69a3.08,3.08,0,0,0,3.09-3.05V22.7l2.77,2.73a1.41,1.41,0,0,0,2,0,1.38,1.38,0,0,0,0-2ZM14.12,15.3a5.68,5.68,0,0,0-.59,2.54v.26a5.68,5.68,0,0,0,.27,1.47,6.15,6.15,0,0,0,2,2.83,4.82,4.82,0,0,0,1.74.85h0a5.21,5.21,0,0,0,2.48.09v1.11a1.35,1.35,0,0,1-1.36,1.34H6.17A1.36,1.36,0,0,1,4.8,24.45V8.25A1.36,1.36,0,0,1,6.17,6.91H7.34a1.2,1.2,0,0,0,.84.33h8.51a1.17,1.17,0,0,0,.84-.33h1.16a1.35,1.35,0,0,1,1.36,1.34v4.08a5.32,5.32,0,0,0-4.88,1.5m0,0a6,6,0,0,0-1.05,1.47M15.25,18v-.11A3.84,3.84,0,0,1,19,13.93l.35,0,.18,0a.9.9,0,0,1,.16,0l.17,0,.18.05.23.08a3.69,3.69,0,0,1,.94.54l.24.18a4,4,0,0,1,1.3,3V18A3.89,3.89,0,0,1,19,22,3.9,3.9,0,0,1,15.25,18Z"
        />
        <path
          className="svg-fill-activity"
          d="M6.78,23.3h5.74a.72.72,0,1,0,0-1.41H6.78a.72.72,0,1,0,0,1.41Z"
        />
        <path
          className="svg-fill-activity"
          d="M6.84,17.49h4.3a.82.82,0,0,0,.91-.7.82.82,0,0,0-.91-.71H6.84a.83.83,0,0,0-.92.71C5.92,17.18,6.33,17.49,6.84,17.49Z"
        />
        <path
          className="svg-fill-activity"
          d="M6.84,11.69h8c.52,0,.92-.31.92-.71s-.4-.7-.92-.7H6.84c-.51,0-.92.31-.92.7A.83.83,0,0,0,6.84,11.69Z"
        />
      </g>
    </g>
  </svg>
);

export default SVG;
